import axios from 'axios'

const { REACT_APP_UNLEASH_URL, REACT_APP_UNLEASH_CLIENT_KEY, REACT_APP_API_ENV } = process.env

const APP_NAME = 'fe-guarantor'
const TIMEOUT_MS = 3000
const CACHE_MS = 60 * 1000

export const FEATURE_FLAGS = {
  privateS3Documents: 'use-private-s3-documents'
}

const cache = {}

/**
 * Lê uma flag na Frontend API do Unleash. Qualquer falha (sem chave, timeout,
 * Unleash fora) devolve false, o que mantém o comportamento atual.
 * @param {string} name FEATURE_FLAGS
 * @param {{ userId?: string }} [context]
 * @returns {Promise<boolean>}
 */
export const isFeatureEnabled = async (name, context = {}) => {
  if (!REACT_APP_UNLEASH_URL || !REACT_APP_UNLEASH_CLIENT_KEY) return false

  const cacheKey = JSON.stringify(context)
  const cached = cache[cacheKey]

  try {
    if (!cached || Date.now() - cached.at > CACHE_MS) {
      const { data } = await axios.get(REACT_APP_UNLEASH_URL, {
        // Staging e produção dividem o ambiente do Unleash; as flags são
        // separadas pela restrição de appEnv.
        params: { appName: APP_NAME, 'properties[appEnv]': REACT_APP_API_ENV, ...context },
        headers: { Authorization: REACT_APP_UNLEASH_CLIENT_KEY },
        timeout: TIMEOUT_MS
      })
      cache[cacheKey] = { at: Date.now(), toggles: (data && data.toggles) || [] }
    }

    return cache[cacheKey].toggles.some(toggle => toggle.name === name && toggle.enabled)
  } catch (err) {
    return false
  }
}
